import React from "react";

import "./carousel.css";
import CarouselItem from "./CarouselItem";

function Carousel({ block, items }) {
  return (
    <div className="carouselWrapper">
      <ul>
        {items.map(({ title, shortDesc, linkToPost, image, alt }, index) => {
          return (
            <CarouselItem key={index} title={title} shortDesc={shortDesc} linkToPost={linkToPost} image={image} alt={alt} block={block} />
          )
        })}
      </ul>
    </div>
  );
}

export default Carousel;
